import BadgeBase from "../BadgeBase";

export default function CounterBadge({ value, tone = "neutral", minWidth = 40, sx }) {
  return (
    <BadgeBase
      tone={tone}
      size="sm"
      minWidth={minWidth}
      sx={{
        px: 1,
        ...sx,
      }}
    >
      {value}
    </BadgeBase>
  );
}
